import { CKContainerProps, CKLayoutGrid } from 'clearkit';
import { FC } from 'react';

import { HomeSidebarSearch } from '~/components/home/HomeSidebar';

export const HomeSidebar: FC<CKContainerProps> = ({ children, ...rest }) => {
  return (
    <CKLayoutGrid
      as="aside"
      gap="0"
      gridTemplateRows="auto 1fr"
      {...rest}
      className="min-h-0 py-8 bg-gray-100 border-t border-gray-200 divide-gray-200"
    >
      <HomeSidebarSearch />
      <div className="min-h-0 px-8 space-y-8 divide-y ck-scrollbar ck-scrollbar--vertical">
        {children}
      </div>
    </CKLayoutGrid>
  );
};
